import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const SubNavStyles = styled.div`
  // made pos relative so item list offset could be adjusted left as needed
  position: relative;

  .filter-button {
    background-color: #fff;
    border: solid 1px ${Colors.accent.grey4.standard};
    border-radius: 100px;
    margin: 5px;
    padding: 0 12px;
    white-space: nowrap; // keep multi word button text from wrapping

    &.active {
      color: ${Colors.primary.claytonBlue.standard};
      border-color: ${Colors.primary.claytonBlue.standard};
    }
    &.changed {
      background-color: ${Colors.primary.claytonBlue.standard};
      color: #fff;
    }
    &:hover {
      cursor: pointer;
    }
  }
`;
